'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompetitorsDirective = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _competitorsDir = require('./competitors.dir.scss');

var _competitorsDir2 = _interopRequireDefault(_competitorsDir);

var _newDependent = require('../../../new-dependent');

var _newDependent2 = _interopRequireDefault(_newDependent);

var _competitorsDir3 = require('./competitors.dir.html');

var _competitorsDir4 = _interopRequireDefault(_competitorsDir3);

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _paths = require('ifeis-isomorphic/lib/redux/actions/accounts/paths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompetitorsDirective = exports.CompetitorsDirective = {
  template: _competitorsDir4.default,
  selector: 'competitors',
  scope: {
    user: '='
  },
  bindToController: true,
  replace: true,
  restrict: 'E',
  controllerAs: 'comp',
  controller: function () {
    function CompetitorsDirectiveCtrl($ngRedux, fNewDependentDialog) {
      var _this = this;

      _classCallCheck(this, CompetitorsDirectiveCtrl);

      this._ = { fNewDependentDialog: fNewDependentDialog };

      $ngRedux.dispatch((0, _accounts.getDependents)(this.user.id));

      $ngRedux.connect(function (state) {
        return {
          competitors: (0, _paths.getDependentsForAccount)(state, _this.user.id).toJS()
        };
      })(this);
    }

    _createClass(CompetitorsDirectiveCtrl, [{
      key: 'addComp',
      value: function addComp($event) {
        this._.fNewDependentDialog($event, this.user);
      }
    }, {
      key: 'editComp',
      value: function editComp($event, old) {
        this._.fNewDependentDialog($event, this.user, old);
      }
    }]);

    return CompetitorsDirectiveCtrl;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./common/directives/competitors/competitors.dir.js
// module id = 471
// module chunks = 0